export default {
  Par: 'par',
  Req: 'req',
}
